import React from "react";
import ModuleBaseList from "./ModuleBaseList";

const ZertifikatsModule: React.FC<{}> = () => {
  return <ModuleBaseList variables={{ where: { ausbildungsArtId: { eq: 2 } } }} isZertifikat />;
};

export default ZertifikatsModule;
